export default [
  'service_fetch_admin@shape',
  'service_fetch_one@shape',
];
